import { createContext } from "react";

export interface SnackbarContext {
  displayError: (message: string) => void;
  displaySuccess: (message: string) => void;
}

const defaultSnackbarContext: SnackbarContext = {
  displayError: () => {},
  displaySuccess: () => {},
};

export const SnackbarContext = createContext(defaultSnackbarContext);
